export const isAlreadyAlertShowing = () => {
	return window.App?.alertQueue ? true : false;
};

export const isAlreadyModalShowing = () => {
	return window.App?.modalQueue ? true : false;
};
